function isPartiallyInViewport(elem) {
	var bounding = elem.getBoundingClientRect();
	return (
		(bounding.top >= 0 && bounding.left >= 0) ||
		(bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth))
	);
}

function isFullyInViewport(elem) {
	var bounding = elem.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

function getFocusableElements(parent) {
	if (!parent) {
		console.warn("You need to pass a parent HTMLElement");
		return [];
	}

	return parent.querySelectorAll(
		'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
	);
}

// function sendGAEvent(action, category, label) {
// 	if (typeof ga === "undefined") return;

// 	var GAevent = {
// 		hitType: "event",
// 		eventCategory: category,
// 		eventAction: action,
// 		eventLabel: label,
// 	};

// 	console.table(GAevent);

// 	// ga("send", GAevent);
// }
